import type { Colors } from '@factorialco/deprecated-design-system'

import type { Filter } from 'modules/core/components/DataTable/types'

import type { GroupByType } from 'modules/performance_analytics/components/helpers'

export interface ChartDataItem {
  [key: string]: string | number
}

export interface EmployeePulseInsightsProps {
  employeeTotalCount: number | null | undefined
  groupBy?: GroupByType
}

export interface ChartTooltipProps {
  chartData: ChartDataItem[]
  groupBy?: GroupByType
  keyColorMap?: Record<string, Colors>
}

export interface ProcessedChartData {
  regularChartData: ChartDataItem[]
  stackedChartData: ChartDataItem[]
  finalKeys: string[]
  maxOfGroupBy: number
  totalCountOfStackedChartData: number
  isEmpty: boolean
  showGroupBy: boolean
  loadingLookups: boolean
}

export interface FilterOption {
  value: unknown
}

export interface FilterState {
  pulseFilter?: Filter<unknown>
  selectedOption?: FilterOption
  filterAlreadyEnabled: boolean
}

export const COLORS: Colors[] = [
  'moodSuperNegative',
  'moodNegative',
  'moodNeutral',
  'moodPositive',
  'moodSuperPositive',
]

export const MOOD_CATEGORIES = ['struggling', 'notGreat', 'okay', 'good', 'great'] as const

export type MoodCategory = (typeof MOOD_CATEGORIES)[number]
